var map = {
	"./1.png": 4251,
	"./10.png": 8907,
	"./11.png": 8258,
	"./12.png": 9354,
	"./2.png": 89,
	"./3.png": 9141,
	"./4.png": 6367,
	"./5.png": 1193,
	"./6.png": 2833,
	"./7.png": 5183,
	"./8.png": 2178,
	"./9.png": 9647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8336;